module.exports = "<script type=\"text/html\" id=\"survey-question-empty\">\n<div></div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/question-empty.html
// module id = 85
// module chunks = 0